"use client";

import { useRouter } from "next/navigation";
import { signOut } from "firebase/auth";
import { useState } from "react";
import { auth } from "@/lib/firebase-util";

const LogoutButton = (props: any) => {
    const [logoutState, setLogoutState] = useState("");
    const router = useRouter();

    const signOutUser = async () => {
        setLogoutState("登出中⋯⋯");
        await signOut(auth);

        const response = await fetch("/api/logout", {
            method: "POST",
        });

        if (response.status === 200) {
            setLogoutState("登出成功！");
            router.push("/");
            router.refresh();
        }
    };

    return (
        <>
            {logoutState && (
                <div
                    key={logoutState}
                    className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-black/30 backdrop-blur-xs"
                >
                    {logoutState}
                </div>
            )}
            <button {...props} onClick={signOutUser}>
                登出
            </button>
        </>
    );
};

export default LogoutButton;
